import Immutable from 'seamless-immutable'
import _ from 'lodash'

import * as actions from './actions'

const initialState = Immutable.from({
  notifications: [],
})

const notifications = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.REMOVE_NOTIFICATION:
      return state.set('notifications', state.notifications.filter((n) => n.key !== payload))
    case actions.ADD_NOTIFICATION:
      if (_.find(state.notifications, { message: payload.message })) {
        return state
      }
      return state.set('notifications', [...state.notifications, payload])
    default:
      return state
  }
}

export default notifications
